import { css } from '@compiled/react';

import Avatar from '@atlaskit/avatar';

/**
 * Always shown beside the person's name, so the avatar itself stays silent. Without `src`, ADS's
 * default avatar stands in.
 */
export const JsmPlaygroundPersonAvatar = ({ src }: { src?: string }) => (
	<span aria-hidden="true" css={avatarWrapperStyles}>
		<Avatar size="small" src={src} />
	</span>
);

const avatarWrapperStyles = css({
	display: 'inline-flex',
	flexShrink: 0,
});
